var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { ButtonBorderedKVBase, DefaultModal } from '@/presentation/components';
import { IconPaymentSuccess } from '@/presentation/components/icons';
import { Container, Row } from 'react-bootstrap';
import { useRecoilState } from 'recoil';
import Styles from './modal-checkout-success-styles.scss';
import { manageStudentsAtom } from '../atoms';
const ModalCheckoutSuccess = ({ manageStripe }) => {
    const returnUrl = `${window.location.href}?reload=1`;
    const [manageStudentsState, setManageStudentsState] = useRecoilState(manageStudentsAtom);
    const [loading, setLoading] = useState(false);
    const closeModal = () => {
        setManageStudentsState(prev => (Object.assign(Object.assign({}, prev), { modalCheckoutSuccess: false, modalCheckout: false })));
    };
    const goStripePortal = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const portalSession = yield manageStripe.createStripePortalSession({ returnUrl });
        if (portalSession === null || portalSession === void 0 ? void 0 : portalSession.url) {
            window.location.replace(portalSession === null || portalSession === void 0 ? void 0 : portalSession.url);
        }
    });
    return (React.createElement(DefaultModal, { height: "54.59", hUnit: "vh", width: "35.5", wUnit: "vw", open: manageStudentsState.modalCheckoutSuccess, onClose: closeModal, showClose: true, overlayCustomStyles: { zIndex: 10000 }, contentCustomStyles: { padding: 25 } },
        React.createElement(Container, { className: Styles.wrap },
            React.createElement(Row, null,
                React.createElement(IconPaymentSuccess, null)),
            React.createElement(Row, null,
                React.createElement("span", { className: Styles.title }, `Congrats! You're All Done!`)),
            React.createElement(Row, null,
                React.createElement("span", { className: Styles.title2 }, `Your students have been added!`)),
            React.createElement(Row, null,
                React.createElement("span", { className: Styles.text }, "Now you can view these students in the Manage Students Dashboard.")),
            React.createElement(Row, null,
                React.createElement(ButtonBorderedKVBase, { type: "button", onClick: goStripePortal, loading: loading }, "View subscription")))));
};
export default ModalCheckoutSuccess;
